import { useFlow } from "../../FlowEdit/useFlow";
import {
  DeleteOutlined,
  PlusOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { ModuleIOValueTypeEnum } from "@packages/flow-core/module";
import { FlowNodeInputTypeEnum } from "@packages/flow-core/module/node/constants";
import { FlowNodeInputItemType } from "@packages/flow-core/module/node/types";
import {
  Button,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Switch,
  Table,
  FormInstance,
  TableColumnsType,
} from "antd";
import { useRef, useState } from "react";
import styles from "./index.less";

const EditFieldModal = ({
  onClose,
  visible,
  data,
  onConfirm,
}: {
  visible: boolean;
  onClose: () => void;
  data?: FlowNodeInputItemType;
  onConfirm: (data: FlowNodeInputItemType) => void;
}) => {
  const ref = useRef<FormInstance<FlowNodeInputItemType>>(null);
  return (
    <Modal
      title="工具字段参数配置"
      onCancel={onClose}
      open={visible}
      destroyOnClose
      cancelText="取消"
      okText="确认"
      afterClose={() => ref.current?.resetFields()}
      onOk={() => ref.current?.submit()}
    >
      <Form
        ref={ref}
        initialValues={data}
        onFinish={(values: FlowNodeInputItemType) => {
          onConfirm(values);
        }}
        labelCol={{ span: 4 }}
      >
        <Form.Item
          noStyle
          name="type"
          initialValue={FlowNodeInputTypeEnum.hidden}
        >
          <div />
        </Form.Item>
        <Form.Item
          label="必填"
          name="required"
          valuePropName="checked"
          initialValue={false}
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label="字段类型"
          name="valueType"
          noStyle
          initialValue={ModuleIOValueTypeEnum.string}
        >
          <div />
        </Form.Item>
        <Form.Item label="字段Key" name="key" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="字段描述"
          name="toolDescription"
          rules={[{ required: true }]}
        >
          <Input.TextArea autoSize={{ minRows: 5 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default function RenderToolInput({
  moduleId,
  inputs,
  canEdit = false,
}: {
  moduleId: string;
  inputs: FlowNodeInputItemType[];
  canEdit?: boolean;
}) {
  const [editFieldValue, setEditFieldValue] = useState<FlowNodeInputItemType>();
  const [open, setOpen] = useState(false);
  const { deleteModuleInput, addModuleInput, updateModuleInput } = useFlow();

  const cols: TableColumnsType<FlowNodeInputItemType> = [
    { title: "字段名", dataIndex: "key" },
    { title: "字段描述", dataIndex: "toolDescription" },
    { title: "必须", dataIndex: "required" },
    canEdit && {
      title: "操作",
      render(_v: any, data: FlowNodeInputItemType) {
        return (
          <Space>
            <SettingOutlined
              onClick={() => {
                setOpen(true);
                setEditFieldValue(data);
              }}
            />
            <DeleteOutlined
              onClick={() => {
                deleteModuleInput(moduleId, data.key);
              }}
              className={styles.danger}
            />
          </Space>
        );
      },
    },
  ].filter(Boolean) as TableColumnsType<FlowNodeInputItemType>;

  return (
    <>
      <Row justify="space-between" align="middle">
        <span>字段</span>
        <Button
          type="text"
          icon={<PlusOutlined />}
          size="small"
          onClick={() => {
            setEditFieldValue(undefined);
            setOpen(true);
          }}
        >
          新增字段
        </Button>
      </Row>
      <Table
        className="pro-table"
        columns={cols}
        dataSource={inputs}
        pagination={false}
      />
      <EditFieldModal
        visible={open}
        onClose={() => setOpen(false)}
        onConfirm={(data) => {
          if (editFieldValue) {
            updateModuleInput(moduleId, editFieldValue.key, {
              ...editFieldValue,
              ...data,
            });
          } else {
            addModuleInput(moduleId, { ...data, label: data.key });
          }
          setOpen(false);
        }}
        data={editFieldValue}
      />
    </>
  );
}
